import React, { Fragment } from "react";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import { FormControlLabel, Grid, FormControl, Radio, RadioGroup, Typography, FormGroup, FormLabel } from "@material-ui/core";
import CustomCheckbox from "../CustomCheckbox";
import translate from '../../other/translate.json';

export default function FilterShow(props) {
  const classes = useStyles();
  const language = localStorage.getItem('language') || 'Ru';
  const isArchive = props.isArchive
  return (
    <React.Fragment>
      <FormControl component="fieldset" className={classes.root}>
        {/* <FormLabel component="legend" className={classes.header}>{translate.Words[`Show${language}`]}:</FormLabel> */}

        <FormGroup>
          <FormControlLabel key={'FormControlLabel1'}
            control={<CustomCheckbox checked={props.video === '1'}
              onChange={props.click_video} />}
            label={translate.Words[`HasVideo${language}`]}
            className={classes.FClabel}
          />         
        </FormGroup>
      </FormControl>
    </React.Fragment>
  )
}

const useStyles = makeStyles(theme => ({
  root: {
    maxWidth: 285,
  },

  header: {
    marginTop: 20,
    marginBottom: 10,
    fontWeight: 500,
    fontSize: '18px',
    lineHeight: '28px',
    color: '#24262A'
  },

  FClabel: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '16px',
    lineHeight: '24px',
    color: '#8987A2'
  }
}))